import { CustomerRow } from '../../../CustomersV2.types';

type SubStages = CustomerRow['application_sub_stage_object'];
type SubStageKey = keyof SubStages;

const BUSINESS_DETAILS_STEPS: SubStageKey[] = [
  'business_type',
  'business_info',
  'director_info',
];

const SECURITY_STEPS: SubStageKey[] = [
  'id_check',
  'card_details',
  'internal_checks',
  'shareholder_check',
  'personal_guarantor_check',
];

export type StageGroupKey = 'business_details' | 'security';

export interface StageGroupProgress {
  key: StageGroupKey;
  label: string;
  required: number;
  completed: number;
  /** A group requiring no steps is not complete — it has nothing to show. */
  isComplete: boolean;
}

const groupProgress = (
  subStages: SubStages,
  key: StageGroupKey,
  label: string,
  steps: SubStageKey[],
): StageGroupProgress => {
  const required = steps.filter((s) => subStages[s]?.required);
  const completed = required.filter((s) => subStages[s]?.completed).length;
  return {
    key,
    label,
    required: required.length,
    completed,
    isComplete: required.length > 0 && completed === required.length,
  };
};

export const getStageGroups = (row: CustomerRow): StageGroupProgress[] => [
  groupProgress(
    row.application_sub_stage_object,
    'business_details',
    'Business details',
    BUSINESS_DETAILS_STEPS,
  ),
  groupProgress(
    row.application_sub_stage_object,
    'security',
    'Security checks',
    SECURITY_STEPS,
  ),
];
